<div class="admin-settings-container">
  <app-page-header></app-page-header>

  <!-- Page Content -->
  <div class="page-content">
    <!-- Tab Content -->
    <div class="tab-content">
      @if (activeTab === 'documents') {
        <div class="content-section">
          <div class="section-header">
            <div class="section-title-wrap">
              <button
                class="section-back-btn"
                (click)="router.navigate(['/home'])"
                title="Back to Dashboard"
                aria-label="Back to Dashboard">
                <svg
                  class="back-arrow-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.7"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  aria-hidden="true">
                  <path d="M19 12H5"></path>
                  <path d="M12 19l-7-7 7-7"></path>
                </svg>
              </button>
              <h2 class="section-title">Document Tuning and Training</h2>
              <div class="search-bar-wrapper section-search-box" [class.is-disabled]="documentModels.length === 0" title="Search document models">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="search-icon">
                  <circle cx="11" cy="11" r="8"/>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"/>
                </svg>
                <input type="text" [(ngModel)]="searchQuery" [disabled]="documentModels.length === 0" placeholder="Search Document Model" class="search-input" />
              </div>
            </div>
            <button *ngIf="isAdmin" class="btn-add-document" (click)="addDocument()" title="Add Document">
              <span class="material-icons">add</span>
              <span>Add Document</span>
            </button>
          </div>
          
          @if (isLoadingDocuments) {
            <div class="page-loading-state">
              <div class="docsila-loader">
                <div class="beat-loader">
                  <div class="beat"></div>
                  <div class="beat"></div>
                  <div class="beat"></div>
                  <div class="beat"></div>
                  <div class="beat"></div>
                </div>
                <p class="loader-text">Loading document models...</p>
              </div>
            </div>
          } @else {
          @if (documentModels.length > 0) {
            <!-- Document Models Table -->
            <div class="document-table-container" (scroll)="onWindowScrollOrResize()">
              <table class="document-table">
                <thead>
                  <tr>
                    <th class="sortable doc-model-header" (click)="sortBy('name')">
                      <div class="th-with-search">
                        <span class="th-label">Document Model <span class="sort-icon" [innerHTML]="getSortIcon('name')"></span></span>
                      </div>
                    </th>
                    <th class="sortable" (click)="sortBy('fields')">
                      Fields <span class="sort-icon" [innerHTML]="getSortIcon('fields')"></span>
                    </th>
                    <th class="sortable" (click)="sortBy('modifiedDate')">
                      Last Modified On <span class="sort-icon" [innerHTML]="getSortIcon('modifiedDate')"></span>
                    </th>
                    <th class="sortable" (click)="sortBy('modifiedBy')">
                      Last Modified By <span class="sort-icon" [innerHTML]="getSortIcon('modifiedBy')"></span>
                    </th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  @for (model of filteredDocumentModels; track model.name) {
                    <tr class="model-row">
                      <td>
                        <span class="document-code-single clickable" 
                              (click)="editFields(model.name)"
                              [title]="model.name">
                          {{ model.name }}
                        </span>
                      </td>
                      <td class="fields-cell">
                        <span class="field-count-badge">{{ model.fieldCount }}</span>
                      </td>
                      <td>
                        @if (model.lastModifiedDate) {
                          <div class="last-modified-cell">
                            <div class="modified-date">{{ model.lastModifiedDate | date:'mediumDate' }}</div>
                            <div class="modified-time">{{ model.lastModifiedDate | date:'shortTime' }}</div>
                          </div>
                        } @else {
                          <span class="empty-cell-dash" aria-label="No last-modified date">—</span>
                        }
                      </td>
                      <td>
                        @if (model.lastModifiedBy) {
                          <span class="modified-by">{{ model.lastModifiedBy }}</span>
                        } @else {
                          <span class="empty-cell-dash" aria-label="No last-modified-by user">—</span>
                        }
                      </td>
                      <td class="action-buttons">
                        <button *ngIf="isAdmin" class="btn-action btn-edit btn-icon-only"
                          (click)="openEditModal(model.name)"
                          [disabled]="downloadingModel === model.name || importingModel === model.name"
                          title="Edit Model Settings">
                          <span class="material-icons icon-action">edit</span>
                        </button>
                        <button *ngIf="isAdmin" class="btn-action btn-wand btn-icon-only"
                          (click)="openPromptTuning(model.name)"
                          [disabled]="downloadingModel === model.name || importingModel === model.name"
                          title="Prompt Tuning">
                          <span class="material-icons icon-action">auto_fix_high</span>
                        </button>
                        <button class="btn-action btn-download btn-icon-only" 
                          (click)="downloadSchema(model.name)"
                          [disabled]="downloadingModel === model.name || importingModel === model.name"
                          title="Download Prompt">
                          @if (downloadingModel === model.name) {
                            <span class="spinner"></span>
                          } @else {
                            <span class="material-icons icon-action">download</span>
                          }
                        </button>
                        <button 
                          *ngIf="isSuperUser"
                          class="btn-action btn-import btn-icon-only" 
                          (click)="importSchema(model.name)"
                          [disabled]="downloadingModel === model.name || importingModel === model.name"
                          title="Import Schema (Super User Only)">
                          <span class="material-icons icon-action">upload</span>
                        </button>
                        <button
                          *ngIf="isSuperUser"
                          class="btn-action btn-import btn-icon-only"
                          (click)="openCompareModal(model.name)"
                          [disabled]="downloadingModel === model.name || importingModel === model.name"
                          title="Compare with Another Environment (Super User Only)">
                          <span class="material-icons icon-action">compare_arrows</span>
                        </button>
                      </td>
                    </tr>
                  } @empty {
                    <tr>
                      <td colspan="5" class="empty-search-row">
                        <div class="empty-search-state">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                            <circle cx="11" cy="11" r="8"/>
                            <path d="m21 21-4.35-4.35"/>
                          </svg>
                          <span>No matching document models found</span>
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          } @else {
            <div class="document-table-container no-data-wrapper">
              <p class="no-data-text">No data available</p>
            </div>
          }
          }
        </div>
      }

      @if (activeTab === 'general') {
        <div class="content-section">
          <h2 class="section-title">General Configuration</h2>
          <div class="empty-state">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
            <p>Configuration options will be available soon.</p>
          </div>
        </div>
      }

      @if (activeTab === 'users') {
        <div class="content-section">
          <h2 class="section-title">User Configuration</h2>
          <div class="empty-state">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
              <circle cx="9" cy="7" r="4"/>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
            </svg>
            <p>Configuration options will be available soon.</p>
          </div>
        </div>
      }
    </div>
  </div>
</div>

@if (isCreateModalOpen) {
  <div class="create-modal-overlay" (click)="onCreateModalBackdropClick()">
    <div class="create-modal-card" (click)="$event.stopPropagation()">
      <div class="create-modal-header">
        <h3>Create Document Model</h3>
        <button class="create-modal-close" (click)="requestCloseCreateModal()" [disabled]="isCreateSubmitting" aria-label="Close create modal">×</button>
      </div>

      <div class="create-modal-body">
        @if (isCreateModalLoading) {
          <div class="create-modal-loading-state">
            <div class="docsila-loader">
              <div class="beat-loader" aria-hidden="true">
                <div class="beat"></div>
                <div class="beat"></div>
                <div class="beat"></div>
                <div class="beat"></div>
                <div class="beat"></div>
              </div>
              <p class="loader-text">Loading form options...</p>
            </div>
          </div>
        } @else {
        <div class="create-form-grid">
          <div class="create-form-column">
            <div class="create-form-field">
              <label>Client Name <span class="required">*</span></label>
              <input type="text" [(ngModel)]="createModalForm.clientName" placeholder="Client name" disabled />
            </div>

            <div class="create-form-field">
              <label>Document Model <span class="required">*</span></label>
              <input type="text" [(ngModel)]="createModalForm.documentModel" placeholder="Enter document model" />
            </div>

            <div class="create-form-field custom-select-field">
              <label>Indexing Model</label>
              <button type="button" class="custom-select-trigger"
                cdkOverlayOrigin #createDocTypeTrigger="cdkOverlayOrigin"
                (click)="toggleCreateDocTypeDropdown()"
                [disabled]="isSequencingDocumentTypesLoading">
                <span class="custom-select-value" [class.placeholder]="!createModalForm.documentType">
                  {{ createModalForm.documentType ? getDocumentTypeName(createModalForm.documentType) : 'Select indexing model' }}
                </span>
                <span class="custom-select-arrow"></span>
              </button>
              <ng-template cdkConnectedOverlay
                [cdkConnectedOverlayOrigin]="createDocTypeTrigger"
                [cdkConnectedOverlayOpen]="isCreateDocTypeDropdownOpen"
                [cdkConnectedOverlayWidth]="createDocTypeTrigger.elementRef.nativeElement.offsetWidth"
                [cdkConnectedOverlayPositions]="[{originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top'}]"
                [cdkConnectedOverlayWidth]="createDocTypeTrigger.elementRef.nativeElement.offsetWidth"
                [cdkConnectedOverlayHasBackdrop]="true"
                cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
                (backdropClick)="isCreateDocTypeDropdownOpen = false; cdr.markForCheck()"
                (detach)="isCreateDocTypeDropdownOpen = false; cdr.markForCheck()">
                <div class="custom-select-panel-wrap">
                  <div class="dropdown-search-container">
                    <input class="dropdown-search-input" placeholder="Search indexing model"
                      [value]="createDocTypeSearch"
                      (input)="onCreateDocTypeSearchInput($event)"
                      (click)="$event.stopPropagation()">
                    @if (createDocTypeSearch) {
                      <button type="button" class="clear-search-btn" (click)="clearCreateDocTypeSearch(); $event.stopPropagation()">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                      </button>
                    }
                  </div>
                  <ul class="custom-select-panel">
                    @for (dt of getFilteredCreateDocTypes(); track dt.code) {
                      <li class="custom-select-option" [class.is-selected]="createModalForm.documentType === dt.code"
                        (click)="selectCreateDocType(dt)">{{ dt.name }}</li>
                    } @empty {
                      <li class="custom-select-empty">No matching indexing models</li>
                    }
                  </ul>
                </div>
              </ng-template>
            </div>

            <div class="create-form-field">
              <label>Document Context</label>
              <textarea class="context-type-textarea" [(ngModel)]="createModalForm.contextType" rows="4" placeholder="Enter document context"></textarea>
            </div>
          </div>

          <div class="create-form-column">
            <div class="create-form-field">
              <label>LLM Model</label>
              <select [(ngModel)]="createModalForm.llmModel" [disabled]="llmModels.length === 0">
                <option value="">{{ llmModelPlaceholder }}</option>
                @for (model of llmModels; track model) {
                  <option [value]="model">{{ model }}</option>
                }
              </select>
            </div>

            <div class="create-form-field">
              <label>LLM Token Limit</label>
              <select [(ngModel)]="createModalForm.llmTokenLimit">
                <option value="">{{ llmTokenLimitPlaceholder }}</option>
                @for (token of tokenLimits; track token) {
                  <option [value]="token">{{ token }}</option>
                }
              </select>
            </div>

            <div class="create-form-field">
              <label>OCR Mode</label>
              <select [(ngModel)]="createModalForm.ocrMode" [disabled]="ocrModes.length === 0">
                <option value="">{{ ocrModePlaceholder }}</option>
                @for (ocrMode of ocrModes; track ocrMode) {
                  <option [value]="ocrMode">{{ ocrMode }}</option>
                }
              </select>
            </div>
            <div class="create-form-field other-details-field">
              <div class="other-details-header">
                <label>Other Details (JSON Format)</label>
                <label class="toggle-label">
                  <input type="checkbox" [(ngModel)]="createModalForm.enableExternalMapping" />
                  <span>Enable External Key Mapping</span>
                </label>
              </div>
              <textarea
                [(ngModel)]="createModalForm.otherDetails"
                rows="4"
                placeholder='Example: {"split_mode":"batched","attributes_per_batch":80}'
                [class.invalid-json]="isOtherDetailsJsonInvalid"></textarea>
              @if (isOtherDetailsJsonInvalid) {
                <div class="field-error">Invalid JSON format</div>
              }
            </div>
          </div>
        </div>
        }
      </div>

      <div class="create-modal-footer">
        <button class="btn-cancel" (click)="requestCloseCreateModal()" [disabled]="isCreateSubmitting">Cancel</button>
        <button class="btn-create" (click)="submitCreateDocumentModel()" [disabled]="isCreateButtonDisabled">
          @if (isCreateSubmitting) {
            Creating...
          } @else {
            Create Model
          }
        </button>
      </div>
    </div>
  </div>
}

@if (isEditModalOpen && !authService.isReadOnly) {
  <div class="edit-modal-overlay" (click)="onEditModalBackdropClick()">
    <div class="edit-modal-card" (click)="$event.stopPropagation()">
      <div class="edit-modal-header">
        <h3>Edit Document Model</h3>
        <button class="edit-modal-close" (click)="requestCloseEditModal()" [disabled]="isEditSubmitting" aria-label="Close edit modal">×</button>
      </div>

      <div class="edit-modal-body">
        @if (isEditModalLoading) {
          <div class="edit-modal-loading-state">
            <div class="docsila-loader">
              <div class="beat-loader" aria-hidden="true">
                <div class="beat"></div>
                <div class="beat"></div>
                <div class="beat"></div>
                <div class="beat"></div>
                <div class="beat"></div>
              </div>
              <p class="loader-text">Loading model settings...</p>
            </div>
          </div>
        } @else {
        <div class="edit-form-grid">
          <div class="edit-form-column">
            <div class="edit-form-field">
              <label>Client Name</label>
              <input type="text" [(ngModel)]="editModalForm.clientName" placeholder="Client name" disabled />
            </div>

            <div class="edit-form-field">
              <label>Document Model</label>
              <input type="text" [(ngModel)]="editModalForm.documentModel" placeholder="Document model" disabled />
            </div>

            <div class="edit-form-field custom-select-field">
              <label>Indexing Model</label>
              <button type="button" class="custom-select-trigger"
                cdkOverlayOrigin #editDocTypeTrigger="cdkOverlayOrigin"
                (click)="toggleEditDocTypeDropdown()"
                [disabled]="authService.isReadOnly || isSequencingDocumentTypesLoading">
                <span class="custom-select-value" [class.placeholder]="!editModalForm.documentType">
                  {{ editModalForm.documentType ? getDocumentTypeName(editModalForm.documentType) : 'Select indexing model' }}
                </span>
                <span class="custom-select-arrow"></span>
              </button>
              <ng-template cdkConnectedOverlay
                [cdkConnectedOverlayOrigin]="editDocTypeTrigger"
                [cdkConnectedOverlayOpen]="isEditDocTypeDropdownOpen"
                [cdkConnectedOverlayWidth]="editDocTypeTrigger.elementRef.nativeElement.offsetWidth"
                [cdkConnectedOverlayPositions]="[{originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top'}]"
                [cdkConnectedOverlayWidth]="editDocTypeTrigger.elementRef.nativeElement.offsetWidth"
                [cdkConnectedOverlayHasBackdrop]="true"
                cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
                (backdropClick)="isEditDocTypeDropdownOpen = false; cdr.markForCheck()"
                (detach)="isEditDocTypeDropdownOpen = false; cdr.markForCheck()">
                <div class="custom-select-panel-wrap">
                  <div class="dropdown-search-container">
                    <input class="dropdown-search-input" placeholder="Search indexing model"
                      [value]="editDocTypeSearch"
                      (input)="onEditDocTypeSearchInput($event)"
                      (click)="$event.stopPropagation()">
                    @if (editDocTypeSearch) {
                      <button type="button" class="clear-search-btn" (click)="clearEditDocTypeSearch(); $event.stopPropagation()">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                      </button>
                    }
                  </div>
                  <ul class="custom-select-panel">
                    @for (dt of getFilteredEditDocTypes(); track dt.code) {
                      <li class="custom-select-option" [class.is-selected]="editModalForm.documentType === dt.code"
                        (click)="selectEditDocType(dt)">{{ dt.name }}</li>
                    } @empty {
                      <li class="custom-select-empty">No matching indexing models</li>
                    }
                  </ul>
                </div>
              </ng-template>
            </div>

            <div class="edit-form-field">
              <label>Document Context</label>
              <textarea class="context-type-textarea" [(ngModel)]="editModalForm.contextType" [disabled]="authService.isReadOnly" rows="4" placeholder="Enter document context"></textarea>
            </div>
          </div>

          <div class="edit-form-column">
            <div class="edit-form-field">
              <label>LLM Model</label>
              <select [(ngModel)]="editModalForm.llmModel" [disabled]="llmModels.length === 0 || authService.isReadOnly">
                <option value="">{{ llmModelPlaceholder }}</option>
                @for (model of llmModels; track model) {
                  <option [value]="model">{{ model }}</option>
                }
              </select>
            </div>

            <div class="edit-form-field">
              <label>LLM Token Limit</label>
              <select [(ngModel)]="editModalForm.llmTokenLimit" [disabled]="authService.isReadOnly">
                <option value="">{{ llmTokenLimitPlaceholder }}</option>
                @for (token of tokenLimits; track token) {
                  <option [value]="token">{{ token }}</option>
                }
              </select>
            </div>

            <div class="edit-form-field">
              <label>OCR Mode</label>
              <select [(ngModel)]="editModalForm.ocrMode" [disabled]="ocrModes.length === 0 || authService.isReadOnly">
                <option value="">{{ ocrModePlaceholder }}</option>
                @for (ocrMode of ocrModes; track ocrMode) {
                  <option [value]="ocrMode">{{ ocrMode }}</option>
                }
              </select>
            </div>

            <div class="edit-form-field other-details-field">
              <div class="other-details-header">
                <label>Other Details (JSON Format)</label>
                <label class="toggle-label">
                  <input type="checkbox" [(ngModel)]="editModalForm.enableExternalMapping" [disabled]="authService.isReadOnly" />
                  <span>Enable External Key Mapping</span>
                </label>
              </div>
              <textarea
                [(ngModel)]="editModalForm.otherDetails"
                [disabled]="authService.isReadOnly"
                rows="4"
                placeholder='Example: {"split_mode":"batched","attributes_per_batch":80}'
                [class.invalid-json]="isEditOtherDetailsJsonInvalid"></textarea>
              @if (isEditOtherDetailsJsonInvalid) {
                <div class="field-error">Invalid JSON format</div>
              }
            </div>
          </div>
        </div>
        }
      </div>

      <div class="edit-modal-footer">
        <button class="btn-cancel" (click)="requestCloseEditModal()" [disabled]="isEditSubmitting">Cancel</button>
        <button class="btn-save" (click)="requestSaveEditDocumentModel()" [disabled]="isEditSaveDisabled">
          @if (isEditSubmitting) {
            Saving...
          } @else {
            Save
          }
        </button>
      </div>
    </div>
  </div>
}

@if (isCompareModalOpen && isSuperUser) {
  <div class="compare-modal-overlay">
    <div class="compare-modal-card" (click)="$event.stopPropagation()">
      <div class="edit-modal-header">
        <h3>Compare Environments</h3>
        <button class="edit-modal-close" (click)="closeCompareModal()" aria-label="Close compare modal">×</button>
      </div>
      <div class="edit-modal-subheader">{{ compareModel }}</div>

      <div class="compare-controls">
        <label for="compareTargetEnv">Compare with</label>
        <select id="compareTargetEnv" [(ngModel)]="compareTargetEnv" (ngModelChange)="onCompareTargetChange()" [disabled]="isComparing">
          <option value="" disabled hidden>Select environment</option>
          @for (env of compareEnvOptions; track env) {
            <option [value]="env">{{ env.toUpperCase() }}</option>
          }
        </select>
        <button class="btn-save" (click)="runCompare()" [disabled]="!compareTargetEnv || isComparing">
          @if (isComparing) {
            Comparing...
          } @else {
            Compare
          }
        </button>
        @if (compareResult?.status === 'DIFFERENT') {
          <div class="compare-sync-actions">
            <button class="btn-push" (click)="openPushDialog()" [disabled]="isComparing || isPushing || isPulling">
              <span class="material-icons sync-icon">arrow_upward</span>Push
            </button>
            <button class="btn-pull" (click)="openPullDialog()" [disabled]="isComparing || isPushing || isPulling">
              <span class="material-icons sync-icon">arrow_downward</span>Pull
            </button>
          </div>
        }
        @if (compareResult?.status === 'TARGET_NOT_FOUND') {
          <div class="compare-sync-actions">
            <button class="btn-push" (click)="openPushDialog()" [disabled]="isComparing || isPushing || isPulling" title="Create this document model in target environment">
              <span class="material-icons sync-icon">add</span>Create document model
            </button>
          </div>
        }
      </div>

      <div class="compare-modal-body">
        @if (isComparing) {
          <div class="edit-modal-loading-state">
            <div class="docsila-loader">
              <div class="beat-loader" aria-hidden="true">
                <div class="beat"></div>
                <div class="beat"></div>
                <div class="beat"></div>
                <div class="beat"></div>
                <div class="beat"></div>
              </div>
              <p class="loader-text">Fetching both environments...</p>
            </div>
          </div>
        } @else if (compareError) {
          <div class="compare-banner compare-banner-error">{{ compareError }}</div>
        } @else if (compareResult) {
          @switch (compareResult.status) {
            @case ('SAME') {
              <div class="compare-banner compare-banner-same">
                No differences. {{ compareTargetEnv.toUpperCase() }} matches this environment ({{ currentEnv.toUpperCase() }}) (ignored: {{ compareResult.ignored_keys.join(', ') }}).
              </div>
            }
            @case ('TARGET_NOT_FOUND') {
              <div class="compare-banner compare-banner-warning">
                '{{ compareModel }}' does not exist in {{ compareTargetEnv.toUpperCase() }}. It must be created there before it can be updated.
              </div>
            }
            @default {
              <div class="compare-banner compare-banner-warning">
                {{ compareResult.differences.length }} difference(s) found between this environment ({{ currentEnv.toUpperCase() }}) and {{ compareTargetEnv.toUpperCase() }}.
              </div>
              <table class="compare-diff-table">
                <thead>
                  <tr>
                    <th>Field</th>
                    <th>This environment ({{ currentEnv.toUpperCase() }})</th>
                    <th>{{ compareTargetEnv.toUpperCase() }}</th>
                  </tr>
                </thead>
                <tbody>
                  @if (getFieldDiffs(compareResult.differences).length > 0) {
                    @for (diff of getFieldDiffs(compareResult.differences); track diff.path) {
                      <tr>
                        <td class="compare-diff-path">
                          <button
                            type="button"
                            class="compare-diff-path-link"
                            title="Jump to this field in the JSON below"
                            (click)="scrollToPath(diff.path)"
                          >
                            @for (segment of formatDiffPath(diff.path); track $index) {
                              @if (!$first) {
                                <span class="compare-diff-path-separator">›</span>
                              }
                              <span class="compare-diff-path-segment">{{ segment }}</span>
                            }
                          </button>
                        </td>
                        <td class="compare-diff-current">{{ formatCompareValue(diff.current) }}</td>
                        <td class="compare-diff-target">{{ formatCompareValue(diff.target) }}</td>
                      </tr>
                    }
                  }
                  @if (getConfigDiffs(compareResult.differences).length > 0) {
                    <tr class="compare-diff-section-row"><td colspan="3">Configuration</td></tr>
                    @for (diff of getConfigDiffs(compareResult.differences); track diff.path) {
                      <tr>
                        <td class="compare-diff-path">
                          <button
                            type="button"
                            class="compare-diff-path-link"
                            title="Jump to this field in the JSON below"
                            (click)="scrollToPath(diff.path)"
                          >
                            @for (segment of formatDiffPath(diff.path); track $index) {
                              @if (!$first) {
                                <span class="compare-diff-path-separator">›</span>
                              }
                              <span class="compare-diff-path-segment">{{ segment }}</span>
                            }
                          </button>
                        </td>
                        <td class="compare-diff-current">{{ formatCompareValue(diff.current) }}</td>
                        <td class="compare-diff-target">{{ formatCompareValue(diff.target) }}</td>
                      </tr>
                    }
                  }
                </tbody>
              </table>
            }
          }

          <div class="compare-panels">
            <div class="compare-panel">
              <div class="compare-panel-title">This environment ({{ currentEnv.toUpperCase() }})</div>
              <pre class="compare-json" #currentJsonPanel>@for (line of compareCurrentLines; track $index) {<span class="compare-line" [class.changed]="line.changed">{{ line.text }}</span>}</pre>
            </div>
            <div class="compare-panel">
              <div class="compare-panel-title">{{ compareTargetEnv.toUpperCase() }}</div>
              @if (compareResult.target) {
                <pre class="compare-json" #targetJsonPanel>@for (line of compareTargetLines; track $index) {<span class="compare-line" [class.changed]="line.changed">{{ line.text }}</span>}</pre>
              } @else {
                <div class="compare-panel-empty">Document model not found in this environment ({{ compareTargetEnv.toUpperCase() }})</div>
              }
            </div>
          </div>
        } @else {
          <div class="compare-empty-state">Select an environment and click Compare.</div>
        }
      </div>

      <div class="edit-modal-footer">
        <button class="btn-close" (click)="closeCompareModal()" [disabled]="isPushing || isPulling">Close</button>
      </div>
    </div>
  </div>

  @if (isPushDialogOpen) {
    <div class="push-dialog-overlay">
      <div class="push-dialog-card" (click)="$event.stopPropagation()">
        <div class="edit-modal-header">
          @if (compareResult?.status === 'TARGET_NOT_FOUND') {
            <h3>Create in Environment</h3>
          } @else {
            <h3>Push to Environment</h3>
          }
        </div>
        <div class="push-dialog-body">
          @if (compareResult?.status === 'TARGET_NOT_FOUND') {
            <p>Create <strong>{{ compareModel }}</strong> in <strong>{{ pushTargetEnv.toUpperCase() }}</strong> using this environment's configuration.</p>
          } @else {
            <p>Push the current configuration of <strong>{{ compareModel }}</strong> to <strong>{{ pushTargetEnv.toUpperCase() }}</strong>. This overwrites the target's configuration.</p>
          }
        </div>
        <div class="edit-modal-footer">
          <button class="btn-cancel" (click)="closePushDialog()" [disabled]="isPushing">Cancel</button>
          <button class="btn-save" (click)="runPush()" [disabled]="!pushTargetEnv || isPushing">
            @if (compareResult?.status === 'TARGET_NOT_FOUND') {
              @if (isPushing) {
                Creating...
              } @else {
                Create
              }
            } @else {
              @if (isPushing) {
                Pushing...
              } @else {
                Push
              }
            }
          </button>
        </div>
      </div>
    </div>
  }

  @if (isPullDialogOpen) {
    <div class="push-dialog-overlay">
      <div class="push-dialog-card" (click)="$event.stopPropagation()">
        <div class="edit-modal-header">
          <h3>Pull from Environment</h3>
        </div>
        <div class="push-dialog-body">
          <p>Pull the configuration of <strong>{{ compareModel }}</strong> from <strong>{{ pullTargetEnv.toUpperCase() }}</strong>. This overwrites this environment's ({{ currentEnv.toUpperCase() }}) configuration.</p>
        </div>
        <div class="edit-modal-footer">
          <button class="btn-cancel" (click)="closePullDialog()" [disabled]="isPulling">Cancel</button>
          <button class="btn-save" (click)="runPull()" [disabled]="!pullTargetEnv || isPulling">
            @if (isPulling) {
              Pulling...
            } @else {
              Pull
            }
          </button>
        </div>
      </div>
    </div>
  }
}

<!-- Hidden file input for schema import -->
<input 
  #fileInput
  type="file" 
  accept=".json,application/json"
  style="display: none;"
  (change)="onFileSelected($event)"
/>

